import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import eyeIcon from "../../../../Assets/icons/eye 1.svg";
import editIcon from "../../../../Assets/icons/Un-Checkbox.svg";

import {
  topDataList,
} from "../../../../constants/SalesCustomerList";

import ROUTES_NAVIGATION from "../../../../routes/routes";
import axiosInstance from "../../../services/api/API";
import SalesListPage from "../SalesComponents/SalesListPage";
import Loader from "../../../customComponents/CustomLoader";
import downloadIcon from "../../../../Assets/icons/download.svg";
import printIcon from "../../../../Assets/icons/printer.svg";
import * as base64 from "base-64";

const ProposalList = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [leadAllocation,setLeadAllocation] = useState([])
  const [currentPage, setCurrentPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [ productdd, setProductdd ] = useState([])
  const [ makedd, setMakedd ] = useState([])
  const [searchQuery, setSearchQuery] = useState('');
  const [validationErrors, setValidationErrors] = useState({});
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("authToken");
  const [filters, setFilters] = useState({});
  const [ filterFormData, setFilterFormData ] = useState({});

  const handleOnAddCustomerButton = () => {
    navigate(ROUTES_NAVIGATION.ADDPROPOSAL);
  };
  useEffect(()=>{
    fethCustomerList()
  },[])
  const fethCustomerList = async (  page = 0, pageSize = 10) => {

    const allfilteredData = filters;
  
    try {
      setLoading(true)
      const response = await axiosInstance.post('/proposal/list', {
      
        orderBy: 'proposal_id desc',
        page,
        pageSize,
        business_partner_id: 1,
        fromDate:filterFormData.fromDate || '', //2024-05-01 date fomat
        toDate:filterFormData.toDate || "",
      searchText:searchQuery || ""
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      });
  
      const formattedData = response.data.data.data.map((item, index) => ({
        ...item,
        "Sr No.": index + 1  ,
        visit_date: new Date(item.visit_date).toLocaleString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true
        }) 
      }));
  
      const totalRecordsData = response?.data?.data?.totalRecords
        console.log(totalRecordsData, "RECORDS")
        setTotalRecords(totalRecordsData);
  
      setLeadAllocation(formattedData);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize)); 
    } catch (error) {
      console.error('Error fetching lead priorities:', error);
    }
    finally{
      setLoading(false)
    }
  };
  const handleCustomerDetails = () => {
    navigate(ROUTES_NAVIGATION.CUSTOMERDETAILSLIST)
  }

  const keyMapping = {
    "Quotation No.":"quotation_code",
    "Transaction No.":"transaction_code",
    "Customer Name": "customer_name",
    "Product": "product_name",
    "Sub Product": "subproduct_name",
    "Model Name": "model_name",
    "Customer Visit Type":"customer_visit_type_name",
    "Variant": "variant_name",
    Color: "color_name",
    Action: [
      { type: "edit", icon: editIcon, label: "Edit" },
      { type: "view", icon: eyeIcon, label: "View" },
      {
        type: "downloadinvoice",
        icon: downloadIcon,
        label: "download Icon",
      },
      {
        
          type: "printInvoice",
          icon: printIcon,
          label: "print Icon",
        
      }
    ],
  };

  const TABLE_HEADERS = [
    "Quotation No.",
    "Transaction No.",
    "Customer Name",
    "Product",
    "Sub Product",
    "Model Name",
    "Variant",
    // "Customer Visit Type",
    "Action",
  ];

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fethCustomerList(newPage);
  };

  const handleViewDetails = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.VIEWPROPOSALLIST}`, { state: { data: rowData } });
  }

  const handleEdit = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.EDITPROPOSAL}`, { state: { data: rowData } });
  }

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      fethCustomerList({ searchText: searchQuery });
    }
  };

  useEffect(() => {
    if (searchQuery === "") {
      fethCustomerList({ searchText: "" });
    }
  }, [searchQuery]);
  

  const handleClearSearch = () => {
    setSearchQuery(""); 
    fethCustomerList(0, 10); 
  };


  const apiCallFunction = () =>{
    fethCustomerList()
  }

  const clearFilter = () => {
    setFilterFormData({});
    fethCustomerList();
  };

  const handleSearch=()=>{
fethCustomerList() 
  }

  const filtersInputs = [
    {
      name: "fromDate",
      label: "From Date",
      type: "date",
      maxDate: new Date(),
      required: false,
      gridClass: "col-lg-5",
  },
    {
        name: "toDate",
        label: "To Date",
        type: "date",
        maxDate: new Date(),
        required: false,
        gridClass: "col-lg-5",
    }
   
  ]


  const handleDownloadInvoice = (rowData) => {
    console.log(rowData, "rowDataquotId")
    var text = rowData?.proposal_id;
    var encoded = base64.encode(text);
    const pdfURL = `http://127.0.0.1:8599/api/v1/proposalpdfreport/proposalDownload/${encoded}`;
    window.open(pdfURL, "_blank", "noopener,noreferrer");
  };


  const handlePrintInvoice = (row) => {
    console.log(row, "clicked")
    navigate(`${ROUTES_NAVIGATION.PROPOSALINVOICE}`, { state: { data: row } });
  }


  return (


    <div>
    {loading ? ( 
      <Loader />
    ) : (
      <div>
        <SalesListPage
            headerTopText="Sales / Proposal List"
            headerTitle="Proposal List"
            addButtonTitle="Add Proposal"
            uploadButtonTitle="Upload Customer"
            isUploadButtonRequired="false"
            listTitle="All Proposals"
            topDetailsList={topDataList}
            tableData={leadAllocation}
            tableHeaders={TABLE_HEADERS}
            keyMapping={keyMapping}
            handleOnAddButton={handleOnAddCustomerButton}
            handleOnUploadButton={() => {}}
            // handleViewButton={handleCustomerDetails}
            onEdit={handleEdit}
            totalRecords={totalRecords} 
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange} 
            handleViewButton={handleViewDetails}
            apiCallFunction={apiCallFunction}
            handleSearchChange={handleSearchChange}
            handleKeyPress={handleKeyPress}
            searchplaceholder="Search by Proposal Name"
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
      
            isFilterRequired= {true}

            handleFormSubmit={handleSearch}
            filterFormData={filterFormData}
            setFilterFormData={setFilterFormData}
            filterInputs={filtersInputs}
            validationErrors={validationErrors}
            setValidationErrors={setValidationErrors}
            handleClear={clearFilter}
            handleClearSearch={handleClearSearch}

            handleDownloadButton={handleDownloadInvoice}
            handlePrintInvoice={handlePrintInvoice}
          />
   </div>
    )}
    </div>
  );
};

export default ProposalList;